import { updateToken } from '../../axios';
import createStore from './createStore';

const removeOldJsonData = (delta, data = {}) => {
  for (const key in data) {
    if (Date.now() > data[key].lastUpdate + delta) {
      delete data[key];
    }
  }
};

const persistedState = localStorage.getItem('FTMS')
  ? JSON.parse(localStorage.getItem('FTMS'))
  : {};

removeOldJsonData(108000000, persistedState?.mentor?.teams);

const reduxStore = createStore(persistedState);

reduxStore.subscribe(() => {
  const state = reduxStore.getState();
  localStorage.setItem(
    'FTMS',
    JSON.stringify({
      account: state.account,
      Intl: state.Intl,
    })
  );
  updateToken({ token: state.account.token });
});

export default reduxStore;
